// extracted by mini-css-extract-plugin
export default {"productsContainer":"products-page_productsContainer__6ajOH"};